import { EventEmitter, Input, Output } from '@angular/core';

export abstract class EasementCreateStepComponent {

  @Input() data: any;
  @Output() backCallback = new EventEmitter();
  @Output() submitCallback = new EventEmitter();
}
